import type { ActivityModule } from '../../core/activity';
import { runMemoryMathActivity, type MemoryMathLevelsFile } from '../../shared/memory-math-runner';
import levelsData from './levels.json';

const LEVELS = (levelsData as MemoryMathLevelsFile).levels;

export const memoryMathDiv: ActivityModule = {
  id: 'memory-math-div',
  title: 'Memória — Divisão',
  description: 'Jogo da memória onde cada par é formado por uma expressão (ex: 12÷3) e seu resultado (4). Treine a tabuada de divisão.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/memory-math-div/icon.svg',
  category: 'memoria',
  totalLevels: LEVELS.length,
  mount: (ctx) =>
    runMemoryMathActivity(ctx, {
      activityId: 'memory-math-div',
      title: 'Memória — Divisão',
      hint: 'Encontre o par: expressão ↔ resultado.',
      levels: LEVELS,
    }),
};
